module.exports = __webpack_public_path__ + "07_mole.728e279a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/07_mole.png
// module id = C44R
// module chunks = 0